"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _globals = require("../../../globals");

var _reducerActions = require("../reducer-actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var toggle = function toggle(dispatch, action, options) {
  try {
    var _dispatch;

    if (typeof action !== 'string') {
      throw TypeError('action prop must be a string');
    }

    dispatch((_dispatch = {
      type: action
    }, _defineProperty(_dispatch, action, false), _defineProperty(_dispatch, "reducerAction", _reducerActions.reducerActionKeys.toggle), _defineProperty(_dispatch, "options", _objectSpread(_objectSpread({}, options), {}, {
      disableMiddleware: true
    })), _dispatch));
  } catch (error) {
    console.error("".concat(_globals.trebleError, " ").concat(error));
  }
};

var _default = toggle;
exports["default"] = _default;
module.exports = exports.default;